import { render, staticRenderFns } from "./ProductStatistics.vue?vue&type=template&id=1b8f716e"
import script from "./ProductStatistics.vue?vue&type=script&lang=js"
export * from "./ProductStatistics.vue?vue&type=script&lang=js"
import style0 from "./ProductStatistics.vue?vue&type=style&index=0&id=1b8f716e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports